import axios from '../axios'
import { BLOCKROUTES } from 'src/router/Api'

export const getListBlock = async (params) => {
	return await axios.get(BLOCKROUTES.name, {
		params,
	})
}

export const deleteBlock = async (id: string) => {
	return await axios.delete(`${BLOCKROUTES.name}/${id}`)
}
